import { initVideoRowSliders } from './videoSlider';
import { initVideoPagination } from './videoPagination';

export default function themeSearch() {
    const input = document.querySelector( '.search-field' );
    const resultsWrapper = document.querySelector( '.video-wrapper' );

    if ( ! input || ! resultsWrapper ) {
        return;
    }

    const triggerLength = parseInt( input.dataset.minLength );
    const originalHTML = resultsWrapper.innerHTML;
    let currentRequest = null;
    let lastQuery = '';

    const ajaxUrl = input.dataset.ajaxUrl;
    const postType = input.dataset.postType;
    const taxonomy = input.dataset.taxonomy;

    function initCategoryScroll() {
        const categoryTabs = document.querySelector( '.category-tabs' );
        const leftBtn = document.getElementById( 'leftBtn' );
        const rightBtn = document.getElementById( 'rightBtn' );

        if ( ! categoryTabs || ! leftBtn || ! rightBtn ) {
            return;
        }

        function updateButtons() {
            const scrollLeft = categoryTabs.scrollLeft;
            const scrollWidth = categoryTabs.scrollWidth;
            const clientWidth = categoryTabs.clientWidth;

            const hasScroll = scrollWidth > clientWidth;

            leftBtn.classList.toggle( 'd-none', ! hasScroll || scrollLeft === 0 );
            rightBtn.classList.toggle( 'd-none', ! hasScroll || scrollLeft >= scrollWidth - clientWidth - 1 );
        }

        leftBtn.addEventListener( 'click', () => {
            categoryTabs.scrollBy( { left: -500, behavior: 'smooth' } );
        } );

        rightBtn.addEventListener( 'click', () => {
            categoryTabs.scrollBy( { left: 500, behavior: 'smooth' } );
        } );

        categoryTabs.addEventListener( 'scroll', updateButtons );
        window.addEventListener( 'resize', updateButtons );

        updateButtons();
    }

    function showLoader() {
        resultsWrapper.innerHTML = `
            <div class="search-loader d-flex justify-content-center align-items-center py-5">
                <div class="text-center">
                    <div class="search-spinner rounded-circle mx-auto mb-4"></div>
                    <p class="text-muted fw-medium mb-0">Searching...</p>
                </div>
            </div>
        `;
    }

    function resetToOriginal() {
        resultsWrapper.innerHTML = originalHTML;
        const leftBtn = document.getElementById( 'leftBtn' );
        if ( leftBtn ) {
            leftBtn.classList.add( 'd-none' );
        }

        requestAnimationFrame( () => {
            initCategoryScroll();
            initVideoRowSliders();
            initVideoPagination();
        } );
    }

    async function sendSearchRequest( query, isUserTriggered = false ) {
        if ( currentRequest ) {
            currentRequest.abort();
        }

        if ( ! query || query.length < triggerLength ) {
            resetToOriginal();
            lastQuery = '';
            return;
        }

        if ( query === lastQuery && ! isUserTriggered ) {
            return;
        }
        lastQuery = query;

        try {
            showLoader();

            const controller = new AbortController();
            currentRequest = controller;

            const url = `${ ajaxUrl }?action=theme_ajax_search&term=${ encodeURIComponent( query ) }&post_type=${ encodeURIComponent( postType ) }&taxonomy=${ encodeURIComponent( taxonomy ) }`;
            const res = await fetch( url, { signal: controller.signal } );

            if ( ! res.ok ) {
                throw new Error( 'Network response was not ok' );
            }
            const data = await res.json();

            if ( data.success && data.data && data.data.html ) {
                resultsWrapper.innerHTML = data.data.html;

                const loadMoreBtn = resultsWrapper.querySelector( '.load-more-categories' );
                if ( loadMoreBtn ) {
                    loadMoreBtn.dataset.search = query;
                    loadMoreBtn.dataset.loaded = '5';
                }

                requestAnimationFrame( () => {
                    initCategoryScroll();
                    initVideoRowSliders();
                    initVideoPagination();
                } );
            } else {
                resultsWrapper.innerHTML = `
                    <div class="search-no-results">
                        <div class="text-center py-5">
                            <p>Error loading results</p>
                        </div>
                    </div>
                `;
            }
        } catch ( error ) {
            if ( error.name === 'AbortError' ) {
                return;
            }

            resultsWrapper.innerHTML = `
                <div class="search-error">
                    <div class="text-center py-5">
                        <h3 class="fs-4 mb-3">Loading Error</h3>
                        <p class="text-muted mb-4">An error occurred during search. Please try again.</p>
                        <button class="btn btn-primary retry-search">Try Again</button>
                    </div>
                </div>
            `;

            const retryBtn = resultsWrapper.querySelector( '.retry-search' );
            if ( retryBtn ) {
                retryBtn.addEventListener( 'click', () => sendSearchRequest( query, true ) );
            }
        } finally {
            currentRequest = null;
        }
    }

    function clearSearch() {
        input.value = '';

        if ( window.location.hash ) {
            history.replaceState( null, '', window.location.pathname + window.location.search );
        }

        resetToOriginal();
        lastQuery = '';
        input.focus();
    }

    function performSearch() {
        if ( currentRequest ) {
            return;
        }
        const query = input.value.trim();
        sendSearchRequest( query, true );
    }

    input.addEventListener( 'input', ( e ) => {
        const query = e.target.value.trim();

        if ( window.location.hash ) {
            history.replaceState( null, '', window.location.pathname + window.location.search );
        }

        if ( ! query ) {
            resetToOriginal();
            lastQuery = '';
        }
    } );

    input.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Enter' ) {
            e.preventDefault();
            performSearch();
        } else if ( e.key === 'Escape' ) {
            clearSearch();
        }
    } );

    initCategoryScroll();
    initVideoRowSliders();
}
